import {ChainId, Currency, NativeCurrency, Token} from "@uniswap/sdk-core";
import {HarmonyChainId} from "./constants";

export function isHarmony(chainId: number) {
  return chainId === HarmonyChainId
}

export const WrappedNativeToken = new Token(
  ChainId.HARMONY,
  '0xcF664087a5bB0237a0BAd6742852ec6c8d69A27a',
  18,
  'WONE',
  'Wrapped ONE'
)

export class HarmonyNativeCurrency extends NativeCurrency {
  equals(other: Currency): boolean {
    return other.isNative && other.chainId === this.chainId
  }

  // @ts-ignore
  get wrapped(): Token {
    if (!isHarmony(this.chainId)) throw new Error('Not harmony')
    return WrappedNativeToken
  }

  public constructor(chainId = HarmonyChainId) {
    if (!isHarmony(chainId)) throw new Error('Not harmony')
    super(chainId, 18, 'ONE', 'ONE')
  }
}

export const NativeToken = new HarmonyNativeCurrency()

export const TokensList: Array<Token | NativeCurrency> = [
  NativeToken,
  WrappedNativeToken,
  new Token(
    ChainId.HARMONY,
    '0x118f50d23810c5E09Ebffb42d7D3328dbF75C2c2',
    8,
    '1WBTC',
    'Wrapped BTC'
  ),
  new Token(
    ChainId.HARMONY,
    '0x6983D1E6DEf3690C4d616b13597A09e6193EA013',
    18,
    '1ETH',
    '1ETH'
  ),
  new Token(
    ChainId.HARMONY,
    '0xF2732e8048f1a411C63e2df51d08f4f52E598005',
    6,
    '1USDT',
    'Tether USD'
  )
]

export const ERC20Tokens: Token[] = TokensList.filter((token) => token.isToken) as Token[]
export const BridgeTokens = [...TokensList]
